var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06417 25.1666L2.38376 28.847C1.97348 29.2573 1.50139 29.3533 0.967505 29.135C0.433616 28.9166 0.166672 28.5133 0.166672 27.925V2.77371C0.166672 2.05565 0.421672 1.44163 0.931672 0.931625C1.44167 0.421625 2.0557 0.166626 2.77376 0.166626H29.2263C29.9443 0.166626 30.5583 0.421625 31.0683 0.931625C31.5783 1.44163 31.8333 2.05565 31.8333 2.77371V22.5595C31.8333 23.2776 31.5783 23.8916 31.0683 24.4016C30.5583 24.9116 29.9443 25.1666 29.2263 25.1666H6.06417Z",
    fill: "#38608F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.ec63ee0a2f55b95241d0d9d7accd943c.svg";
export { ForwardRef as ReactComponent };